import React, { useEffect } from 'react';
import { CenterModal } from 'react-spring-modal';
// import "@reach/dialog/styles.css";
import '../css/modal.css';
import Xbutton from '../assets/icons/closebtn.svg';
import {
	languageSetting,
	translatedText,
} from '../recoil-states/language-state';
import { useRecoilState, useRecoilValue } from 'recoil';
import { createIncrementalProgram } from 'typescript';

export default function TermsOfServiceModal({
	modalVisible,
	_setModalVisible,
	setStakeBtnChecked
}) {
	const textData = useRecoilValue(translatedText);

	return (
		<div id='TermsOfService col'>
			<CenterModal
				className='terms_modal'
				isOpen={modalVisible}
				onDismiss={() => _setModalVisible(false)}
				contentProps={{ style: apllyModalstyle }}
			>
				<div className='T_modal_container col'>
					<div className='T_modal_header'>
						<p>{textData?.TermsOfService.TermsOfServiceHeader}</p>
						<button
							onClick={() => {
								_setModalVisible(false);
							}}
						>
							<img src={Xbutton} alt='' />
						</button>
					</div>
					<div className='T_modal_content'>
						<h1>{textData?.termsModal.mainText}</h1>
						<div>
							<p>{textData?.termsModal.subMainText}</p>
						</div>
						<p>{textData?.termsModal.article1}</p>
						<div>
							<p>{textData?.termsModal.article1_text}</p>
						</div>
						<p>{textData?.termsModal.article2}</p>
						<ul>
							<li>
								{textData?.termsModal.article2_text.en_text ??
									textData?.termsModal.article2_text.en_text}
							</li>
						</ul>
						<ol>
							{textData?.termsModal.article2_text.text.map(
								(item, index) => {
									return <li key={index}>{item}</li>;
								}
							)}
						</ol>

						<p>{textData?.termsModal.article3}</p>
						<ol>
							{textData?.termsModal.article3_text.text.map(
								(item, index) => {
									return <li key={index}>{item}</li>;
								}
							)}
						</ol>

						<p>{textData?.termsModal.article4}</p>

						<ol>
							{textData?.termsModal.article4_text.text.map(
								(item, index) => {
									return <li key={index}>{item}</li>;
								}
							)}
						</ol>
						<p>{textData?.termsModal.acticle5}</p>
						<ol>
							{textData?.termsModal.article5_text.text.map(
								(item, index) => {
									return (
										<>
											<li>{item}</li>
											{index === 3 ? (
												<ol>
													{textData?.termsModal.article5_text.text4_detail.map(
														(
															content,
															itemIndex
														) => {
															return (
																<li
																	key={
																		itemIndex
																	}
																	style={{
																		listStyleType:
																			'lower-alpha',
																	}}
																>
																	{content}
																</li>
															);
														}
													)}
												</ol>
											) : null}
										</>
									);
								}
							)}
						</ol>

						<p>{textData?.termsModal.article6}</p>

						<ul>
							<li>
								{textData?.termsModal.article6_text.text[0] ??
									textData?.termsModal.article6_text.text[0]}
							</li>
						</ul>
						<ol>
							{textData?.termsModal.article6_text.text_detail.map(
								(item, index) => {
									return <li key={index}>{item}</li>;
								}
							)}
						</ol>

						<p>{textData?.termsModal.article7}</p>

						<ol id='article_seven'>
							{textData?.termsModal.article7_text.text.map(
								(item, index) => {
									return <li key={index}>{item}</li>;
								}
							)}
						</ol>
						<p>{textData?.termsModal.article8}</p>

						<ul>
							<li>
								{textData?.termsModal.article8_text.text[0] ??
									textData?.termsModal.article8_text.text[0]}
							</li>
						</ul>
						<p>{textData?.termsModal.article9}</p>
						<ul>
							<li>
								{textData?.termsModal.article9_text.text[0] ??
									textData?.termsModal.article9_text.text[0]}
							</li>
						</ul>
						{textData?.termsModal.article9_text.text.map(
							(item, index) => {
								return (
									<ol>
										{textData?.termsModal.article9_text.text_detail.map(
											(it, id) => {
												return <li key={id}>{it}</li>;
											}
										)}
									</ol>
								);
							}
						)}
						<p>{textData?.termsModal.article10}</p>

						<ul>
							<li>{textData?.termsModal.article10_text}</li>
						</ul>
						<p>{textData?.termsModal.article11}</p>

						<ol>
							{textData?.termsModal.article11_text.text.map(
								(item, index) => {
									return (
										<div key={index}>
											<li>{item}</li>
										</div>
									);
								}
							)}
						</ol>
						<h2>{textData?.termsModal.article12}</h2>
						<h3>{textData?.termsModal.article12_text}</h3>
					</div>
					<div className='T_modal_btn'>
						<button
							onClick={() => {
								_setModalVisible(false);
								setStakeBtnChecked(true);
							}}
						>
							<p>Yes</p>
						</button>
					</div>
				</div>
			</CenterModal>
		</div>
	);
}
const apllyModalstyle = {
	backgroundColor: '#22262B',
	zIndex: '5',
	width: '100%',
	minWidth: '50%',
	border: '1px solid #CCCCCC',
	animation: 'none',
};
